import React, {Component} from 'react';
import MatchWhenLoggedIn from '../MatchWhenLoggedIn';
import {Route, Redirect, Switch} from 'react-router-dom';
import UtentiList from './UtentiList'
import UtentiForm from './UtentiForm'

class UtentiContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (<div>
            <Switch>
                <Route exact path='/app/utenti' render={() => (
                    <Redirect
                        to='/app/utenti/list'
                    />
                )} />
                <MatchWhenLoggedIn path='/app/utenti/list' component={UtentiList} />
                <MatchWhenLoggedIn path='/app/utenti/edit/:id' component={UtentiForm} />
                <MatchWhenLoggedIn path='/app/utenti/new' component={UtentiForm} />
            </Switch>
        </div>)
    }
}

export default UtentiContent;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/UtentiContent.js
 **/